import script from "./LoanApplicationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LoanApplicationForm.vue?vue&type=script&setup=true&lang=js"

import "./LoanApplicationForm.vue?vue&type=style&index=0&id=795d7fb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795d7fb2"]])

export default __exports__